import type { NodeStyle as NodeStyleRichContent } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { CustomTextualStyle } from './../../ricos-types/index.js';

export class RicosNodeStyle {
  nodeStyle: NodeStyleRichContent;

  private constructor(nodeStyle: NodeStyleRichContent) {
    this.nodeStyle = nodeStyle;
  }

  static of(nodeStyle?: NodeStyleRichContent): RicosNodeStyle {
    return new RicosNodeStyle(nodeStyle || {});
  }

  getNodeStyle = (): NodeStyleRichContent => this.nodeStyle;

  static fromCustomStyle = (customStyle: CustomTextualStyle): RicosNodeStyle => {
    const { paddingBottom, paddingTop } = customStyle;
    const nodeStyle = {
      paddingBottom,
      paddingTop,
    };
    return RicosNodeStyle.of(nodeStyle as NodeStyleRichContent);
  };

  toCustomStyle = (): CustomTextualStyle => {
    return { paddingBottom: this.nodeStyle.paddingBottom, paddingTop: this.nodeStyle.paddingTop };
  };

  overrideWith = (nodeStyle: NodeStyleRichContent = {}): RicosNodeStyle => {
    return RicosNodeStyle.of({ ...this.nodeStyle, ...nodeStyle });
  };
}
